import SearchDownShift from "components/downmshift/DownShift";
import FilterTabs from "components/filterTabs/FilterTabs";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat.js";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from 'react-router-dom';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { DateFormetContext } from "../../../../app/App.js";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import Button from "components/button/Button";
import CrossSvg from "assets/icons/svg/cross";
import MyButton from "components/MyButton";
import "../../index.scss";
import "./theme.scss";

function DocumentsNav({
  searchValue,
  setSearchValue,
  filter_by,
  filterTabs,
  filter,
  onStatusChange,
  handleSelect,
  startDate,
  endDate,
  DateRange,
}) {
  const location = useLocation();
  const history = useHistory();
  const [date, setDate] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const dateFormet = React.useContext(DateFormetContext);

  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();

  useEffect(() => {
    if (endDate < startDate) {
      toastr.error('End Date should be greater than start date.')
      DateRange([null, null]);
      setDate([]);
    }
  }, [endDate])

  const isStatusIncluded = filter_by?.map(item => item?.toLowerCase()).includes(filter?.status?.toLowerCase());

  const handleClear = () => {
    setSearchValue("");
    DateRange([null, null]);
    setDate([]);
  };

  return (
    <div className="filteration table-head">
      <div className="activated-ledger d-flex flex-lg-row justify-content-end align-items-center mb-5" style={{ gap: '10px' }}>
        <FilterTabs
          tabs={filterTabs}
          activeTab={isStatusIncluded ? filter?.status?.toLowerCase() : "All"}
          onTabsChange={(tab) => onStatusChange(tab?.value)}
        />
        <Button
          style={openFilter ? { opacity: 0.3 } : {}}
          variant="filter"
          onClick={() => setOpenFilter(!openFilter)}
        >
          <FilterIcon />
          <span>Filter</span>
        </Button>
      </div>
      {openFilter && (
        <div className="filter mb-10">
          <div className="text-right px-5 pt-5">
            <span className="cursor-pointer" onClick={() => setOpenFilter(false)}>
              <CrossSvg />
            </span>
          </div>
          <div className="row pr-12 pl-9 finance-tilter">
            <div className="col-sm-4 col-md-4">
              <label style={{ fontWeight: 600, fontSize: '13px', marginBottom: '6px', display: 'block' }}>Search</label>
              <SearchDownShift
                items={[]}
                name={searchValue}
                setName={setSearchValue}
                placeHolder="Search by Account Name"
                autoFocus
              />
            </div>
            {(filter?.status?.toLowerCase() === "all" || !filter?.status) && (
              <div className="col-sm-4 col-md-4 charged_date">
                <label style={{ fontWeight: 600, fontSize: '13px', marginBottom: '6px', display: 'block' }}>Filter by:</label>
                <DateRangePicker
                  format={dateFormate}
                  placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                  cleanable={true}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  style={{ display: "inline-block", padding: '0', border: '0', width: "100%", color: 'black' }}
                  size="lg"
                  value={date}
                  onChange={(update) => { DateRange(update); setDate(update); }}
                />
              </div>
            )}
          </div>
          <div className="pr-12 pl-9 pb-10 justify-content-end d-flex">
            <MyButton
              type="secondary"
              content={<span className="mx-8">Clear</span>}
              onClick={handleClear}
              style={{ marginRight: 10 }}
            />
            <button
              className="btn btn-primary"
              style={{ width: 70 }}
              onClick={() => setOpenFilter(false)}
            >
              Go
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DocumentsNav;
